module.exports = __webpack_public_path__ + "img/item1-5.169f30e5.png";